import directory from './directory'
import settleIn from './settleIn'

const enterprise = {
  path: 'enterprise',
  component: resolve => require(['../../../../pages/modules/enterprise'], resolve),
  redirect: 'enterprise/directory',
  children: [
    directory,
    settleIn
  ],
  meta: {
    requireAuth: true
  }
}

export default enterprise
